import { Popper } from "@mui/material";
import type { PopperProps } from "@mui/material/Popper";
import type { ReactElement } from "react";
import { SrPopoverGrow } from "./SrPopoverGrow";

export const SrAutocompletePopper = (props: PopperProps) => (
  <Popper {...props} transition>
    {({ TransitionProps }) => (
      <SrPopoverGrow {...TransitionProps}>{props.children as ReactElement}</SrPopoverGrow>
    )}
  </Popper>
);
